'use client'

import Link from 'next/link'
import { useSession } from 'next-auth/react'

// Components

import { buttonVariants } from '@/components/ui/button'
import { Skeleton } from '@/components/ui/skeleton'

// Utils
import { cn } from '@/lib/utils'

export function GetStartedButton() {
  const { data: session, status } = useSession()
  return (
    <div className="">
      {session ? (
        <Link
          href={
            session.user.role === 'ADMIN' ? '/dashboard/admin' : '/dashboard'
          }
          className={cn(
            buttonVariants({ size: 'sm', variant: 'secondary' }),
            'bg-background hover:bg-background/90'
          )}
        >
          Dashboard
        </Link>
      ) : status === 'unauthenticated' ? (
        <Link
          href="/login"
          className={cn(
            buttonVariants({ size: 'sm', variant: 'secondary' }),
            'bg-background hover:bg-background/90'
          )}
        >
          Get started
        </Link>
      ) : (
        <Skeleton className="hidden h-8 w-[98px] rounded-md bg-background lg:flex" />
      )}
    </div>
  )
}
